import React, { Component } from 'react'
import _ from 'lodash'
import { Platform, View } from 'react-native'
import Svg from 'react-native-svg'

import { log, setStatePromise, delay } from 'x/utils/util'
import assets from 'xui/assets'

import QRCode from './QRCode'
import XGalleryModal from './XGalleryModal'
import XText from './XText'
// const X_LOGO = require('../img/logo_1024.png')
const X_LOGO = assets.images.logo1024

export interface QRCodeModalProps {}

export interface QRCodeModalState {
  isVisibleQRCode: boolean
  qrCodeValue: string
  qrCodeBase64: string
  qrCodeLabel?: string
  modalOpenNumber: number
}

export default class QRCodeModal extends Component<QRCodeModalProps, QRCodeModalState> {
  static displayName = 'QRCodeModal'

  inProcess: boolean

  svgQRCodeRef: React.RefObject<Svg>

  constructor(props: QRCodeModalProps) {
    super(props)
    this.state = {
      isVisibleQRCode: false,
      qrCodeValue: null,
      qrCodeBase64: null,
      modalOpenNumber: 0,
    }

    this.inProcess = false
    this.svgQRCodeRef = React.createRef<Svg>()
    // this.openQRCode = this.openQRCode.bind(this)
    // this.closeQRCode = this.closeQRCode.bind(this)
  }

  _openModal = async (): Promise<void> => {
    await setStatePromise(this, { isVisibleQRCode: true, modalOpenNumber: this.state.modalOpenNumber + 1 })
  }

  openQRCode = async (qrCodeValue: string, qrCodeLabel?: string): Promise<void> => {
    console.log('openQRCode qrCodeValue=> ', qrCodeValue)
    console.log('openQRCode qrCodeLabel=> ', qrCodeLabel)
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    if (!qrCodeValue) {
      this.inProcess = false
      return
    }

    console.log('openQRCode this.state.qrCodeValue=> ', this.state.qrCodeValue)
    console.log('openQRCode this.state.qrCodeBase64=> ', this.state.qrCodeBase64)
    if (qrCodeValue === this.state.qrCodeValue && this.state.qrCodeBase64) {
      console.log('openQRCode already have qrCodeBase64, just open modal')
      this._openModal()
      this.inProcess = false
      return
    }
    // log('openQRCode qrCodeValue=> ', qrCodeValue)

    // this.setState({ qrCodeValue }, () => {
    //   this._handleOpenQRCode(qrCodeValue)
    // })
    await setStatePromise(this, { qrCodeValue, qrCodeLabel, modalOpenNumber: this.state.modalOpenNumber + 1 })
    await delay(200)
    await this._handleOpenQRCode(qrCodeValue)
    await delay(200)
    this.inProcess = false
  }

  closeQRCode = async (): Promise<void> => {
    // if (this.inProcess) {
    //   return
    // }
    // this.inProcess = true
    await setStatePromise(this, {
      isVisibleQRCode: false,
      // qrCodeValue: null,
      // qrCodeBase64: null,
    })

    await delay(200)
    // this.svgQRCodeRef = null
    this.inProcess = false
  }

  _handleOpenQRCode = async (qrCodeValue: string): Promise<void> => {
    // log('_handleOpenQRCode qrCodeValue => ', qrCodeValue)
    // await new Promise(delay => setTimeout(delay, 100))
    if (!this.svgQRCodeRef || !_.isFunction(this.svgQRCodeRef.current.toDataURL)) {
      return
    }

    // const data = await this.svgQR.toDataURL()
    // this.svgQRCodeRef.toDataURL(async (data) => {
    //   const qrCodeBase64 = `data:image/png;base64,${data}`
    //   await setStatePromise(this, { isVisibleQRCode: true, qrCodeBase64, qrCodeValue })
    // })

    const data = await new Promise((loadedData) => {
      try {
        this.svgQRCodeRef.current?.toDataURL(loadedData)
      } catch (err) {
        // log(this, '_handleOpenQRCode e => ', e)
        console.log('_handleOpenQRCode e => ', err)
        loadedData(null)
      }
    })

    if (!data) {
      console.log('Cannot get QRCode data')
      return
    }

    console.log('_handleOpenQRCode  data => ', data)

    const qrCodeBase64 = `data:image/png;base64,${data}`
    await setStatePromise(this, { isVisibleQRCode: true, qrCodeBase64, qrCodeValue })

    // this.inProcess = false
  }

  render() {
    const { isVisibleQRCode = false, qrCodeValue = null, qrCodeBase64 = null, qrCodeLabel = null, modalOpenNumber = 0 } = this.state

    return (
      <View
        key={`QR_${qrCodeValue}_${modalOpenNumber}`}
        style={{
          flexWrap: 'wrap',
          // height: 1,
          // width: 1,
          opacity: 0,
          position: 'absolute',
          left: 0,
          bottom: 0,
          // display: 'none',
          ...Platform.select({
            android: { width: 1, height: 1 },
            ios: { width: 1, height: 1 },
          }),
        }}
      >
        <XText>{qrCodeLabel}</XText>
        <XText>{qrCodeValue}</XText>
        {qrCodeBase64 && isVisibleQRCode ? (
          <XGalleryModal
            key={`XG_${qrCodeValue}_${modalOpenNumber}`}
            isVisible
            // isVisible={isVisibleQRCode}
            onRequestClose={this.closeQRCode}
            images={[qrCodeBase64]}
          />
        ) : null}
        {!qrCodeValue || !_.isString(qrCodeValue) || qrCodeValue.length < 5 ? null : (
          <QRCode
            // getRef={(r) => r && (this.svgQRCodeRef = r)}
            innerRef={this.svgQRCodeRef}
            value={qrCodeValue}
            txtBottomQR={qrCodeLabel}
            backgroundColor='white'
            size={200}
            ecl={'H'}
            logo={X_LOGO}
            logoSize={40}
            logoMargin={2}
            logoBackgroundColor='white'
            customPadding={8}
            isVisibleTextValue={true}
            textValueSize={18}
            // logoSize={30}
          />
        )}
      </View>
    )
  }
}
